<script setup>
  import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

  const status = defineModel({ type: String, required: true });
</script>

<template>
  <Tabs
    v-model="status"
    class="self-end">
    <TabsList>
      <TabsTrigger value="open">Open</TabsTrigger>
      <TabsTrigger value="resolved">Resolved</TabsTrigger>
    </TabsList>
  </Tabs>
</template>
